export const governmentReadyPageConstants = {
    title1: '검사 진행을 위해',
    title2: '자녀의 정보를 입력해주세요.',
    headerText: '검사 준비하기',
    bottonText: '다음',
    modalTitle1: '모든 데이터를 삭제하고',
    modalTitle2: '지금 나갈까요?',
    modalContent: '지금 나가면, 첫 단계인 개인정보 동의부터 다시 시작해야합니다. 그래도 나갈까요?',
};
